import { mapGetters } from 'vuex';
import mvtCollapsibleLinks from '@/common/components/mvtcollapsiblelinks/mvt-collapsiblelinks.vue';

var saleLinks = [
    {
        molangLink: 'SFHLink',
        propertyType: 'single-family',
        icon: 'property-single-family'
    },
    {
        molangLink: 'condoLink',
        propertyType: 'condos',
        icon: 'property-condo'
    },
    {
        molangLink: 'foreclosedLink',
        propertyType: 'foreclosed',
        icon: 'auction'
    },
    {
        molangLink: 'openHouseLink',
        propertyType: 'open-houses',
        icon: 'open-house'
    },
    {
        molangLink: 'reducedLink',
        propertyType: 'reduced-30',
        icon: 'trend-down'
    },
    {
        molangLink: 'soldLink',
        propertyType: 'sold',
        icon: 'home-checked'
    }
];

var rentLinks = [
    {
        molangLink: 'rentLink',
        propertyType: 'rentals',
        icon: 'home-checked'
    },
    {
        molangLink: 'houseLink',
        propertyType: 'houses',
        icon: 'property-single-family'
    },
    {
        molangLink: 'apartmentLink',
        propertyType: 'apartments',
        icon: 'property-condo'
    }
];

export default {
    name: 'sitemapPropertyTypes',
    components: {
        mvtCollapsibleLinks
    },
    computed: {
        ...mapGetters('glb', ['glb']),
        stateName() {
            return this.glb.pageData.stateInfo.displayName;
        },
        propertyTypeData() {
            let list = [];
            if(this.glb.rentals) {
                list.push({
                    title: this.molang(`common.sitemap.mainContent.homesLinkRent`, {state: this.stateName}),
                    data: this.getLinksData(rentLinks),
                    show: this.glb.pageData && !this.glb.pageData.letter
                })
            } else {
                list.push({
                    title: this.molang(`common.sitemap.mainContent.homesLink`, {state: this.stateName}),
                    data: this.getLinksData(saleLinks),
                    show: true
                })
                //only disable for state case, but looks like the rent links should not be added for all cases
                if (this.glb.pageType !== 'vsitemap_state') {
                    list.push({
                        title: this.molang(`common.sitemap.mainContent.homesLinkRent`, { state: this.stateName }),
                        data: this.getLinksData(rentLinks),
                        show: this.glb.pageData && !this.glb.pageData.letter,
                    });
                }
            }
            return list;
        }
    },
    methods: {
        getLinksData(links) {
            const data = links.map(item => {
                const propertyType = ['houses','apartments'].includes(item.propertyType) ? 'rentals/' + item.propertyType : item.propertyType;
                item.href = `${this.glb.appUrl}sitemap/${this.glb.pageData.stateInfo.nameForUrl}/${propertyType}/${this.glb.pageData.letter ? `letter-${this.glb.pageData.letter}/` : ''}`;
                item.title = this.molang(`common.sitemap.mainContent.${item.molangLink}`)
                return item;
            });
            return data;
        }
    }
}